// removed by extract-text-webpack-plugin
module.exports = {"bar1":"src-components-Header-MenuButton----menubutton-module---bar1---WE7as","bar2":"src-components-Header-MenuButton----menubutton-module---bar2---T11dJ","bar3":"src-components-Header-MenuButton----menubutton-module---bar3---3YHmN","container":"src-components-Header-MenuButton----menubutton-module---container---1xBN2","close":"src-components-Header-MenuButton----menubutton-module---close---M_80v"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/MenuButton/menubutton.module.css
// module id = 321
// module chunks = 114276838955818